<template>
  <div class="sidenav-inner" :class="{ 'py-1' :orientation !== 'horizontal' }"  v-if="currentUser != '' && currentUser.role[0] == 'agent_wms'">
   
       <sidenav-router-link icon="ion ion-md-speedometer" to="/app"   :exact="true">Dashboard</sidenav-router-link>
      <sidenav-menu icon="fad fa-warehouse" style="--fa-secondary-opacity: 1.0; --fa-primary-color: var(--c-cyan); --fa-secondary-color: var(--c-purple);">
      
      <template slot="link-text">WMS</template>

        <sidenav-menu>
          <template slot="link-text">Receiving and Putaway</template>
              <div v-if="currentType == 0">
                <sidenav-menu>
                  <template slot="link-text">Alkes</template>
                    <sidenav-router-link to="/app/wms/receiving/alkes/thermometer" :exact="true">Thermometer</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/receiving/alkes/tensimeter" :exact="true">Tensimeter</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/receiving/alkes/amalgam" :exact="true">Dental Amalgam</sidenav-router-link>

                </sidenav-menu>
                <sidenav-router-link to="/app/wms/receiving" :exact="true">Pesk</sidenav-router-link> 
              </div> 
              <div v-else-if="currentType == 1">
                <sidenav-menu>
                  <template slot="link-text">Alkes</template>
                    <sidenav-router-link to="/app/wms/receiving/alkes/provinsi/thermometer" :exact="true">Thermometer</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/receiving/alkes/provinsi/tensimeter" :exact="true">Tensimeter</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/receiving/alkes/provinsi/amalgam" :exact="true">Dental Amalgam</sidenav-router-link>

                </sidenav-menu>
                <sidenav-router-link to="/app/wms/pesk/provinsi/receiving" :exact="true">Pesk</sidenav-router-link> 
              </div>

              <div v-else-if="currentType == 2">
                <sidenav-menu>
                  <template slot="link-text">Alkes</template>
                    <sidenav-router-link to="/app/wms/receiving/alkes/final/thermometer" :exact="true">Thermometer</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/receiving/alkes/final/tensimeter" :exact="true">Tensimeter</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/receiving/alkes/final/amalgam" :exact="true">Dental Amalgam</sidenav-router-link>

                </sidenav-menu>
                <sidenav-router-link to="/app/wms/pesk/final/receiving" :exact="true">Pesk</sidenav-router-link> 
              </div>
              
        </sidenav-menu>
      
      

        <sidenav-menu>
            <template slot="link-text">Pengemasan Ulang</template>
              <sidenav-menu v-if="currentType == 0">
                  <template slot="link-text">Alkes</template>
                    <sidenav-router-link to="/app/wms/pengemasan/ulang/thermometer" :exact="true">Thermometer</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/pengemasan/ulang/tensimeter" :exact="true">Tensimeter</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/pengemasan/ulang/amalgam" :exact="true">Dental Amalgam</sidenav-router-link>

              </sidenav-menu>
              <sidenav-menu v-if="currentType == 1">
                  <template slot="link-text">Alkes</template>
                    <sidenav-router-link to="/app/wms/pengemasan/ulang/provinsi/thermometer" :exact="true">Thermometer</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/pengemasan/ulang/provinsi/tensimeter" :exact="true">Tensimeter</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/pengemasan/ulang/provinsi/amalgam" :exact="true">Dental Amalgam</sidenav-router-link>

              </sidenav-menu>

              <sidenav-menu v-if="currentType == 2">
                  <template slot="link-text">Alkes</template>
                    <sidenav-router-link to="/app/wms/pengemasan/ulang/final/thermometer" :exact="true">Thermometer</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/pengemasan/ulang/final/tensimeter" :exact="true">Tensimeter</sidenav-router-link>
                    <sidenav-router-link to="/app/wms/pengemasan/ulang/final/amalgam" :exact="true">Dental Amalgam</sidenav-router-link>

              </sidenav-menu>

           
            <sidenav-router-link to="/app/wms/pengemasan/ulang" :exact="true" v-if="currentType == 0">Pesk</sidenav-router-link>
            <sidenav-router-link to="/app/wms/pengemasan/ulang/provinsi" :exact="true" v-if="currentType == 1">Pesk</sidenav-router-link>
            <sidenav-router-link to="/app/wms/pengemasan/ulang/final" :exact="true" v-if="currentType == 2">Pesk</sidenav-router-link>
        </sidenav-menu>

        <sidenav-router-link to="/app/wms/agent/dispatching" :exact="true">
                Dispatching
        </sidenav-router-link>

        <div v-if="currentType == 0">
          <sidenav-router-link to="/app/wms/stock" :exact="true">Stock take (Stock Opname)</sidenav-router-link>
        </div> 
        
        <div v-else-if="currentType == 1">
          <sidenav-router-link to="/app/wms/stock/provinsi" :exact="true">Stock take (Stock Opname)</sidenav-router-link>
        </div>
        <div v-else-if="currentType == 2">
          <sidenav-router-link to="/app/wms/stock/final" :exact="true">Stock take (Stock Opname)</sidenav-router-link>
        </div>

         <sidenav-menu v-if="currentType == 0">
          <template slot="link-text">Reporting</template>
            <sidenav-router-link to="/app/wms/reporting/alkes" :exact="true">Alkes</sidenav-router-link>
            <sidenav-router-link to="/app/wms/reporting" :exact="true">Pesk</sidenav-router-link>
        </sidenav-menu>

        <sidenav-menu v-if="currentType == 1">
          <template slot="link-text">Reporting</template>
            <sidenav-router-link to="/app/wms/reporting/provinsi/alkes" :exact="true">Alkes</sidenav-router-link>
            <sidenav-router-link to="/app/wms/reporting/provinsi/pesk" :exact="true">Pesk</sidenav-router-link>
        </sidenav-menu>

        <sidenav-menu v-if="currentType == 2">
          <template slot="link-text">Reporting</template>
            <sidenav-router-link to="/app/wms/reporting/final/alkes" :exact="true">Alkes</sidenav-router-link>
            <sidenav-router-link to="/app/wms/reporting/final/pesk" :exact="true">Pesk</sidenav-router-link>
        </sidenav-menu>

     
    </sidenav-menu>

    <sidenav-menu icon="fad fa-layer-group" style="--fa-secondary-opacity: 1.0; --fa-primary-color: var(--c-cyan); --fa-secondary-color: var(--c-purple);">
        <template slot="link-text">Master Data</template>
         
          <sidenav-router-link to="/app/masterwms/storage-management" :exact="true"
            >Borang Master WMS</sidenav-router-link
          >
    </sidenav-menu>


  
  </div>
</template>
<script>
import {
  Sidenav,
  SidenavLink,
  SidenavRouterLink,
  SidenavMenu,
  SidenavHeader,
  SidenavBlock,
  SidenavDivider
} from "@/vendor/libs/sidenav";
export default {
  data: () => ({}),
  components: {
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },

    currentType() {
      return this.$store.state.auth.user.type;
    },
  },
  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },
  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  },
  
};
</script>
